import PropTypes from "prop-types";

export const productShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  terms: PropTypes.string,
  artworkUrl: PropTypes.string,
  scope: PropTypes.string.isRequired,
  venueNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  expiresInMonths: PropTypes.number,
  denominationsCents: PropTypes.arrayOf(PropTypes.number).isRequired,
  customMinCents: PropTypes.number,
  customMaxCents: PropTypes.number,
  maxPerOrder: PropTypes.number.isRequired,
  bonus: PropTypes.shape({
    amountCents: PropTypes.number.isRequired,
    minAmountCents: PropTypes.number.isRequired,
    endsOn: PropTypes.string,
  }),
});

export const teamShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  location: PropTypes.string,
  logoUrl: PropTypes.string,
  accentColor: PropTypes.string,
});

export const deliveryShape = PropTypes.shape({
  earliestDate: PropTypes.string.isRequired,
  latestDate: PropTypes.string.isRequired,
  timeLabel: PropTypes.string.isRequired,
});

export const quoteShape = PropTypes.shape({
  subtotal_cents: PropTypes.number.isRequired,
  fees_cents: PropTypes.number.isRequired,
  total_cents: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  amount_cents: PropTypes.number,
  quantity: PropTypes.number,
  bonus_cents: PropTypes.number,
  bonus_offer: PropTypes.shape({
    amount_cents: PropTypes.number.isRequired,
    min_amount_cents: PropTypes.number.isRequired,
    ends_on: PropTypes.string,
  }),
});
